var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn-cu btn-color-estandar",class:[{ 'btn-disabled': _vm.disabled }, _vm.size],attrs:{"href":"#"}},[_c('icono-clave-unica',{staticClass:"cl-claveunica",style:({
      fill: _vm.disabled ? '#9E9E9E' : 'white',
    })}),_c('span',{staticClass:"texto"},[_vm._t("default",function(){return [_vm._v("Iniciar sesión")]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }